import { render, staticRenderFns } from "./ScreenGuiasFacturador.vue?vue&type=template&id=680c5554&scoped=true"
import script from "./ScreenGuiasFacturador.vue?vue&type=script&lang=js"
export * from "./ScreenGuiasFacturador.vue?vue&type=script&lang=js"
import style0 from "./ScreenGuiasFacturador.vue?vue&type=style&index=0&id=680c5554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c5554",
  null
  
)

export default component.exports